// extracted by mini-css-extract-plugin
export default {"container":"Xj-z","blurb":"Yj-z","links":"Zj-z"};